<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
      <v-container>
        <v-btn small fab class="mb-3" color="primary" @click="showNewItemForm = !showNewItemForm">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <template v-if="showNewItemForm">
          <v-form ref="newItemForm" v-model="validItem">
            <v-row no-gutters>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="newItem.title"
                  :label="$gettext('Title')"
                  outlined
                  class="px-2"
                  :rules="[required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="newItem.authors"
                  :label="$gettext('Authors')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="newItem.pages"
                  :label="$gettext('Pages')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="newItem.volume"
                  :label="$gettext('Volume')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="newItem.year"
                  :label="$gettext('Year')"
                  outlined
                  class="px-2"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="newItem.published_in"
                  :label="$gettext('Published in')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="newItem.publisher"
                  :label="$gettext('Publisher')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="newItem.web_url"
                  :label="$gettext('Web URL')"
                  outlined
                  class="px-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="newItem.abstract"
                  :label="$gettext('Abstract')"
                  outlined
                  class="px-2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-2" @click="addItem">
              <translate>Add</translate>
            </v-btn>
          </v-row>
        </template>
        <v-alert v-if="error" type="error">
          <translate>Error</translate>
        </v-alert>
        <p v-if="bibliographicReferences.length == 0" class="font-weight-thin ml-2" v-translate>No items.</p>
        <v-list v-else flat>
          <v-list-item
            v-for="item in bibliographicReferences"
            :key="item.id"
            style="border: 1px solid #e0e0e0; border-radius: 5px"
            color="primary"
          >
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="primary--text">
              <v-row no-gutters align="center">
                <v-btn class="ml-3" icon @click="itemToEdit = item; showEditItem = true">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn class="ml-1" icon @click="itemToDelete = item; showDeleteItem = true;">
                  <v-icon color="primary">mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-dialog v-model="showEditItem" max-width="80%" scrollable>
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">
              <translate>Edit</translate>
            </v-card-title>
            <v-card-text class="pt-2">
              <v-form ref="editItemForm" v-model="validItem">
                <v-row no-gutters>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="itemToEdit.title"
                      :label="$gettext('Title')"
                      outlined
                      class="px-2"
                      :rules="[required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="itemToEdit.authors"
                      :label="$gettext('Authors')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="itemToEdit.pages"
                      :label="$gettext('Pages')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="itemToEdit.volume"
                      :label="$gettext('Volume')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="itemToEdit.year"
                      :label="$gettext('Year')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="itemToEdit.published_in"
                      :label="$gettext('Published in')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="itemToEdit.publisher"
                      :label="$gettext('Publisher')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="itemToEdit.web_url"
                      :label="$gettext('Web URL')"
                      outlined
                      class="px-2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="itemToEdit.abstract"
                      :label="$gettext('Abstract')"
                      outlined
                      class="px-2"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary darken-1" text @click="showEditItem = false">
                <translate key="close">Close</translate>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="editItem">
                <translate key="save">Save</translate>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <DeleteConfirmationDialog v-model="showDeleteItem" item="bibliographic_reference" @delete="deleteItem" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "BibliographicReferences",
  components: {
    NavBar,
    DeleteConfirmationDialog
	},
  data: () => ({
    bibliographicReferences: [],
    showNewItemForm: false,
    newItem: {
      title: null,
      authors: null,
      pages: null,
      volume: null,
      year: null,
      published_in: null,
      publisher: null,
      web_url: null,
      abstract: null
    },
    validItem: false,
    showEditItem: false,
    itemToEdit: {},
    showDeleteItem: false,
    itemToDelete: {},
    error: false
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
    },
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Bibliographic References"),
					disabled: true,
					link: true
				}
			];
		}
  },
  methods: {
    getForm(item) {
      const form = new FormData();
      form.append("title", item.title);
      if(item.authors) form.append("authors", item.authors);
      if(item.pages) form.append("pages", item.pages);
      if(item.volume) form.append("volume", item.volume);
      if(item.year) form.append("year", item.year);
      if(item.published_in) form.append("published_in", item.published_in);
      if(item.publisher) form.append("publisher", item.publisher);
      if(item.web_url) form.append("web_url", item.web_url);
      if(item.abstract) form.append("abstract", item.abstract);
      return form;
    },
    addItem() {
      this.error = false;
      if (this.$refs.newItemForm.validate()) {
        const form = this.getForm(this.newItem);
				axios
					.post(
						"/admin/bibliographic-references/new",
						form
					)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.bibliographicReferences.push(response.data.item);
              this.showNewItemForm = false;
            } else {
              this.error = true;
            }
					})
					.catch(error => {
            console.log(error);
            this.error = true;
          });
      }
    },
    editItem() {
      this.error = false;
      if (this.$refs.editItemForm.validate()) {
        const form = this.getForm(this.itemToEdit);
        axios
					.post(
						"/admin/bibliographic-references/" + this.itemToEdit.id + "/edit",
						form
					)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.showEditItem = false;
            } else {
              this.error = true;
            }
					})
					.catch(error => {
            console.log(error);
            this.error = true;
          });
      }
    },
    deleteItem() {
      axios
				.post(
					"/admin/bibliographic-references/" + this.itemToDelete.id + "/delete"
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted"){
						this.bibliographicReferences.splice(this.bibliographicReferences.indexOf(this.itemToDelete), 1);
						this.showDeleteItem = false;
					}
					else {
						this.showDeleteItem = false;
						this.error = true;
					}
				})
				.catch(error => {
          console.log(error);
          this.error = true;
        });
    }
  },
  created() {
		axios
			.get("/admin/bibliographic-references")
			.then(response => {
				console.log(response.data);
				this.bibliographicReferences = response.data.bibliographic_references;
			})
			.catch(error => console.log(error));
	}
}
</script>